import { render, staticRenderFns } from "./OktaSso.vue?vue&type=template&id=61f00810&scoped=true"
import script from "./OktaSso.vue?vue&type=script&lang=ts"
export * from "./OktaSso.vue?vue&type=script&lang=ts"
import style0 from "./OktaSso.vue?vue&type=style&index=0&id=61f00810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f00810",
  null
  
)

export default component.exports